import {Component, NgZone} from "@angular/core";

import {ModalConfig} from "../services/notification/modal.config";
import {EventBus} from "../event/EventBus";
import "rxjs/add/operator/map";
import "rxjs/add/operator/subscribeOn";
import {ComponentBase} from "../base/ComponentBase";
import {BugsnagLoggingService} from "../services/logging/bugsnag-logging.service";
import {PipelineEvent, PIPELINE_STATUS} from "../event/PipelineEvent";


import {NavigationEvent} from "../event/NavigationEvent";
import {PipelineService} from "../services/pipeline/pipeline.service";
import {IMetaData} from  "../api/data-model";
import {HttpClient} from "@angular/common/http";
import {filter} from "rxjs/operators";

@Component({
    selector: "pipeline-modal",
    templateUrl: "./pipeline.modal.component.html",
    styleUrls: ["./pipeline.component.scss"]
})
export class PipelineModalComponent extends ComponentBase {

    public activateModal: boolean = false;
    public status:string = "";
    public filteredTitles:Array<IMetaData> = new Array<IMetaData>();
    public get unpublishedTitles() {
        return this.filteredTitles.filter(title => title.contentVersion === 'UNPUBLISHED');
    }
    public showOnlyUnpublishedTitles: boolean = false;
    public toggleShowOnlyUnpublishedTitles() {
        this.showOnlyUnpublishedTitles = !this.showOnlyUnpublishedTitles;
    }
    public search: string;
    public filterNew: boolean = false;
    public initialized: boolean = false;

    constructor(private http: HttpClient,
        private eventBus: EventBus,
        private modalConfig: ModalConfig,
        private logService: BugsnagLoggingService,
        private _ngZone: NgZone,
        private pipelineService:PipelineService
    ) {
        super("PipelineModalComponent");
        this.subscribeObserve();
    }

    private subscribeObserve():void {
        let sub = this.eventBus.pipe(filter((e:PipelineEvent) =>
                                       (e.type === PipelineEvent.TYPE) && (e.status === PIPELINE_STATUS.manual)))
            .subscribe((e:PipelineEvent) => {
                console.log("activating pipeline modal refactored");
                if (!this.initialized) {
                    this.pipelineService.populateData(this.filterNew, false).subscribe(filtered => {
                        this.filteredTitles = filtered;
                        this.initialized = true;
                    });
                } else {
                    this.filteredTitles =
                        this.pipelineService.filterTitles(this.search, this.filterNew, false);
                }
                this.activateModal = true;
            });
        this.subscriptions.push(sub);
    }

    public closeModal(): void {
        this.filteredTitles.splice(0, this.filteredTitles.length);
        this.activateModal = false;
    }

    public isDevMode(): boolean {
        return this.pipelineService.isDevMode();
    }

    public selectTitle(title:string):void {
        this.pipelineService.retrieveUninflatedContent(title).subscribe(content => {
            console.log("retrieved title content: " + content);
            if (content) {
                this.eventBus.next(new NavigationEvent(["reading", title], {queryParams: {isPipeline: true}}));
            }
            this.closeModal();
        });
    }

    public runFilterNew():void {
        this.filterNew = !this.filterNew;
        this.filteredTitles = this.pipelineService.filterTitles(this.search, this.filterNew, false);
    }

    public filterTitles():void {
        this.filteredTitles = this.pipelineService.filterTitles(this.search, this.filterNew, false);
    }

}
